import { CloudFlowNodeType } from "@doitintl/cmp-models";

import { CHANGE_TRIGGER_OPTIONS } from "../../types";

export const getTriggerByOption = (option: CHANGE_TRIGGER_OPTIONS) => {
  switch (option) {
    case CHANGE_TRIGGER_OPTIONS.SCHEDULED:
      return CloudFlowNodeType.TRIGGER;
    case CHANGE_TRIGGER_OPTIONS.MANUAL:
      return CloudFlowNodeType.MANUAL_TRIGGER;
    case CHANGE_TRIGGER_OPTIONS.WEBHOOK:
      return CloudFlowNodeType.WEBHOOK_TRIGGER;
    // case CHANGE_TRIGGER_OPTIONS.SYSTEM_EVENT:
    //   return CloudFlowNodeType.SYSTEM_EVENT_TRIGGER;
    default:
      return undefined;
  }
};

export const getOptionByTrigger = (trigger: CloudFlowNodeType) => {
  switch (trigger) {
    case CloudFlowNodeType.TRIGGER:
      return CHANGE_TRIGGER_OPTIONS.SCHEDULED;
    case CloudFlowNodeType.MANUAL_TRIGGER:
      return CHANGE_TRIGGER_OPTIONS.MANUAL;
    case CloudFlowNodeType.WEBHOOK_TRIGGER:
      return CHANGE_TRIGGER_OPTIONS.WEBHOOK;
    // TODO: uncomment to enable system event node
    // case CloudFlowNodeType.SYSTEM_EVENT_TRIGGER:
    //   return CHANGE_TRIGGER_OPTIONS.SYSTEM_EVENT;
    default:
      return CHANGE_TRIGGER_OPTIONS.NONE;
  }
};
